module.exports = __webpack_public_path__ + "img/tree-group-black.7e0fc9da.svg";